"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const validator_1 = __importDefault(require("validator"));
const ValidationUtils_1 = require("../util/ValidationUtils");
class ContactFormStore {
    constructor(rootStore) {
        Object.defineProperty(this, "captchaPassed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "emailContent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                body: '',
                phone: '',
                from: '',
                requestType: ''
            }
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this);
        this.translateStore = rootStore.translateStore;
    }
    get isEmailValid() {
        return validator_1.default.isEmail(this.emailContent.from);
    }
    get isPhoneValid() {
        return this.emailContent.phone === '' || ValidationUtils_1.PHONE_REGEXP.test(this.emailContent.phone);
    }
    get isBodyValid() {
        return this.emailContent.body.length > 5;
    }
    reset() {
        this.emailContent = { body: '', phone: '', from: '', requestType: '' };
        this.captchaPassed = false;
    }
}
exports.default = ContactFormStore;
__decorate([
    mobx_1.observable
], ContactFormStore.prototype, "captchaPassed", void 0);
__decorate([
    mobx_1.observable
], ContactFormStore.prototype, "emailContent", void 0);
__decorate([
    mobx_1.computed
], ContactFormStore.prototype, "isEmailValid", null);
__decorate([
    mobx_1.computed
], ContactFormStore.prototype, "isPhoneValid", null);
__decorate([
    mobx_1.computed
], ContactFormStore.prototype, "isBodyValid", null);
__decorate([
    mobx_1.action
], ContactFormStore.prototype, "reset", null);
